import React, { useState } from 'react'

import {
  Edit as EditIcon,
  Home as HomeIcon,
} from '@material-ui/icons'
import { DetailTableProps } from './types'

import { ClientDialog } from 'src/modules/supply_chain/components/ClientDialog'
import { BooleanField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

export const ClientDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <ClientDialog
          open={updateOpen}
          client={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          { Icon: EditIcon, actions: [{ title: 'Edit Client', onClick: () => setUpdateOpen(true) }] },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'isActive', label: 'Active', renderer: BooleanField },
        ]}
      />
    </>
  )
}
